/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-unused-expressions */
import { useCallback, KeyboardEvent } from "react";
import { useHistory } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import * as MUI from "@mui/material";
import * as MUIcons from "@mui/icons-material";

import { celularStoreNome } from "../../../hooks/store";
import { useAuth } from "../../../hooks/auth";

import { LayoutConsultaCelular } from "./LayoutConsultaCelular";
import { ResultadoConsultaCelular } from "../../../components";

type InputProps = {
  nome: string;
};

export const ConsultaCelularNome: React.FC = () => {
  const { control, handleSubmit } = useForm<InputProps>({
    defaultValues: {
      nome: "",
    },
  });
  const history = useHistory();

  const { user } = useAuth();

  const { url } = user!.sistemas.filter((s) => {
    return s.id_sistema === 1 ? s.url : false;
  })[0];

  const {
    consultaCelularNome,
    resultadoCelularNome,
    limparConsultaCelularNome,
  } = celularStoreNome((state) => state.celular);

  const handlePesquisaPorNome = (data: InputProps) => {
    consultaCelularNome(url, data.nome);
  };

  const keyBoardClick = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
    e.key === "Enter";
  }, []);

  const { loading } = celularStoreNome((state) => state.global);

  function handleRedirectImei(IMEI: string) {
    return history.push("/alerta/consulta-celular/ficha-celular", {
      imei: IMEI,
    });
  }

  return (
    <LayoutConsultaCelular>
      <MUI.Grid
        component="form"
        alignItems="center"
        width={["100%", "100%", "100%", "80%", "60%"]}
        container
        spacing={1}
        onSubmit={handleSubmit(handlePesquisaPorNome)}
      >
        <MUI.Grid item xs={12} md={4} sm={4}>
          <Controller
            name="nome"
            control={control}
            render={({ field: { onChange, value } }) => (
              <MUI.TextField
                label="Informe o nome"
                value={value}
                onChange={onChange}
                onKeyPress={keyBoardClick}
                fullWidth
                size="small"
                disabled={loading}
              />
            )}
          />
        </MUI.Grid>

        <MUI.Grid item xs={12} md={3} sm={3}>
          <MUI.Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            disabled={loading}
            startIcon={<MUIcons.Search />}
          >
            <MUI.Typography
              variant="button"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              Consultar
            </MUI.Typography>
          </MUI.Button>
        </MUI.Grid>
        <MUI.Grid item xs={12} md={3} sm={3}>
          <MUI.Button
            fullWidth
            variant="outlined"
            color="secondary"
            onClick={limparConsultaCelularNome}
            disabled={loading}
            startIcon={<MUIcons.Clear />}
          >
            <MUI.Typography
              variant="button"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              Limpar resultado
            </MUI.Typography>
          </MUI.Button>
        </MUI.Grid>
      </MUI.Grid>

      <MUI.Stack>
        {resultadoCelularNome ? (
          <MUI.Typography variant="h6">
            Resultado da consulta:
            {!loading && resultadoCelularNome?.length === 0 && (
              <MUI.Typography variant="body1">
                Nenhum resultado
              </MUI.Typography>
            )}
          </MUI.Typography>
        ) : (
          false
        )}

        {!loading ? (
          resultadoCelularNome &&
          resultadoCelularNome.map((resultado) => (
            <ResultadoConsultaCelular
              key={resultado.IMEI}
              situacao={
                resultado.SITUACAOALERTA === 0 ? "NÃO ALERTADO" : "ALERTADO"
              }
              imei={resultado.IMEI}
              marca={resultado.MARCA}
              modelo={resultado.MODELO}
              onClick={() => handleRedirectImei(resultado.IMEI)}
            />
          ))
        ) : (
          <MUI.LinearProgress />
        )}
      </MUI.Stack>
    </LayoutConsultaCelular>
  );
};
